var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.count),function(i,index){return _c('v-skeleton-loader',{key:index,staticClass:"mt-3",attrs:{"type":"text"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }